






import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import {getSpectrumFreqFormatted} from '@/api/configApi';
import Highcharts from 'highcharts';
import {ActionDiagramData} from '@/interfaces/diagrams';

Highcharts.setOptions({
  lang: {
    resetZoom: 'Сбросить зум',
    resetZoomTitle: 'Сброс уровня масштабирования 1:1',
  },
});

@Component({
  components: {
    highchart: Chart,
  },
})
export default class ActionDiagram extends Vue {
  @Prop({required: true, type: Object})
  data!: ActionDiagramData;

  leftX = 0;
  rightX = 0;
  dataLength = 0;
  xTitle = '';
  yTitle = '';

  spectrum: {x: number; y: number}[] = [];

  // Метод установки начального состояния графика
  @Watch('data')
  onLoadData() {
    if (!this.data) return;

    const chart = this.getChart();
    chart.zoomOut();

    const {values, leftX, rightX, size, xTitle, yTitle} = this.data;

    this.xTitle = xTitle;
    this.yTitle = yTitle;
    this.leftX = leftX;
    this.rightX = rightX;
    this.dataLength = size;
    this.spectrum = values.map((value: number, index: number) => ({
      x: getSpectrumFreqFormatted(index, leftX, rightX, size),
      y: value,
    }));
  }

  get chartOptions() {
    return {
      credits: {
        enabled: false,
      },
      title: '',
      xAxis: {
        title: {
          text: this.xTitle,
        },
      },
      yAxis: {
        title: {
          text: this.yTitle,
        },
      },
      series: [
        {
          data: this.spectrum,
          type: 'line',
        },
      ],
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
      plotOptions: {
        series: {
          animation: {
            duration: 0,
          },
          states: {
            hover: {
              enabled: false,
              halo: {
                size: 0,
              },
              inactive: {
                enabled: false,
              },
            },
          },
        },
        line: {
          turboThreshold: 0,
          boostThreshold: 0,
          animation: {
            duration: 0,
          },
          marker: {
            enabled: false,
            radius: 0,
          },
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
      },
      chart: {
        animation: false,
        zoomType: 'xy',
        events: {
          selection: (e: any) => {
            if (e.xAxis) this.extremesX.push({min: e.xAxis[0].min, max: e.xAxis[0].max});
            if (e.yAxis) this.extremesY.push({min: e.yAxis[0].min, max: e.yAxis[0].max});
          },
        },
      },
      legend: false,
      tooltip: {
        enabled: false,
        crosshairs: [false],
      },
    };
  }

  getChart() {
    return (this.$refs.chart as any).chart;
  }

  //Границы зума по X
  extremesX: any[] = [];

  //Границы зума по Y
  extremesY: any[] = [];

  //Отмена текущего зума
  undoZoom() {
    if (this.extremesX.length === 0 && this.extremesY.length === 0) return;

    const chart = this.getChart();

    if (this.extremesX.length > 0) this.extremesX.pop();
    if (this.extremesY.length > 0) this.extremesY.pop();

    if (this.extremesX.length === 0 && this.extremesY.length === 0) {
      chart.zoomOut();
      return;
    }

    const currentX = chart.xAxis[0].getExtremes();
    const currentY = chart.yAxis[0].getExtremes();

    if (this.extremesX.length > 0) {
      const prevExtremesX = this.extremesX[this.extremesX.length - 1];
      if (currentX.min !== prevExtremesX.min || currentX.max !== prevExtremesX.max)
        chart.xAxis[0].setExtremes(prevExtremesX.min, prevExtremesX.max);
    }

    if (this.extremesY.length > 0) {
      const prevExtremesY = this.extremesY[this.extremesY.length - 1];
      if (currentY.min !== prevExtremesY.min || currentY.max !== prevExtremesY.max)
        chart.yAxis[0].setExtremes(prevExtremesY.min, prevExtremesY.max);
    }
  }
}
